/**
 * Hybrid Indicator Component
 * Automatically chooses between Tailwind and styled-components based on props
 */

import * as React from "react";
import Icon from "@sproutsocial/seeds-react-icon";
import Container from "./styles"; // Styled-components version
import { IndicatorTailwind } from "./IndicatorTailwind"; // Tailwind version
import { hasStyledProps } from "@sproutsocial/seeds-react-system-props";
import type { TypeIndicatorProps } from "./IndicatorTypes";

export const IndicatorHybrid = ({
  tooltip = "",
  ...rest
}: TypeIndicatorProps) => {
  if (hasStyledProps(rest)) {
    return (
      <Container
        data-tip={tooltip}
        data-qa-indicator=""
        aria-label={tooltip}
        tabIndex={0}
        {...rest}
      >
        {tooltip && <div>{tooltip}</div>}
        <Icon name="circle-fill-solid" size="mini" aria-hidden />
      </Container>
    );
  }

  // Use Tailwind version (preferred - better performance)
  return <IndicatorTailwind tooltip={tooltip} {...rest} />;
};

IndicatorHybrid.displayName = "Indicator";
